document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('.expandable-tabs');

  containers.forEach(function (container) {
    var allowMultiple = container.dataset.allowMultiple === 'true';
    var items = container.querySelectorAll('.expandable-tabs__item');

    items.forEach(function (item) {
      var trigger = item.querySelector('.expandable-tabs__trigger');
      var panel = item.querySelector('.expandable-tabs__panel');

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('expandable-tabs__item--open');

        if (!allowMultiple) {
          items.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.classList.contains('expandable-tabs__item--open')) {
              closePanel(otherItem);
            }
          });
        }

        if (isOpen) {
          closePanel(item);
        } else {
          openPanel(item);
        }
      });
    });

    function openPanel(item) {
      var trigger = item.querySelector('.expandable-tabs__trigger');
      var panel = item.querySelector('.expandable-tabs__panel');

      item.classList.add('expandable-tabs__item--open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;

      var height = panel.scrollHeight;
      panel.style.height = '0px';
      requestAnimationFrame(function () {
        panel.style.height = height + 'px';
      });

      panel.addEventListener('transitionend', function handler() {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', handler);
      });
    }

    function closePanel(item) {
      var trigger = item.querySelector('.expandable-tabs__trigger');
      var panel = item.querySelector('.expandable-tabs__panel');

      var height = panel.scrollHeight;
      panel.style.height = height + 'px';

      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });

      item.classList.remove('expandable-tabs__item--open');
      trigger.setAttribute('aria-expanded', 'false');

      panel.addEventListener('transitionend', function handler() {
        if (!item.classList.contains('expandable-tabs__item--open')) {
          panel.hidden = true;
        }
        panel.removeEventListener('transitionend', handler);
      });
    }
  });
});
